import {
  Box,
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
  InputBase,
} from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import { useEffect, useState } from "react";

// services
import { validateBuildingName } from "../../utils/input-validations";
import { axiosInstance } from "../../services/api/api";

// svg
import { ReactComponent as IconReload } from "../../assets/svg/reload.svg";
import { usePlannerContext } from "../../services/context/planner-context";

const CustomInput = styled(InputBase)(({ theme, small, error }) => ({
  "label + &": {
    marginTop: "20px",
  },
  "& .MuiInputBase-input": {
    color: "#000",
    borderRadius: small ? 6 : 8,
    position: "relative",
    backgroundColor: "#fff" /* '#F3F6F9' */,
    border: "1px solid",
    borderColor: error ? theme.palette.error.main : "#dbdbeb" /* '#E0E3E7' */,
    fontSize: 14,
    lineHeight: 18,
    width: "100%",
    padding: small ? "4px 8px " : "4px 8px",
    transition: theme.transitions.create(["border-color", "background-color"]),
    "&:focus": {
      borderColor: theme.palette.primary.main,
    },
    "&:hover": {
      backgroundColor: "#fff" /* '#F4F4F9' */ /* "#EEEEF6" */,
      borderColor: theme.palette.primary.main,
    },
    "&::placeholder": {
      color: "#e0e0e0",
      fontSize: "12px",
      opacity: 1,
    },
  },
}));

export const TextFieldName = ({
  label,
  unit,
  placeholder,
  requier = false,
  value,
  setValue,
  small = false,
  name = "",
  area,
  type,
  setEditMode,
}) => {
  const { validateStart, setValidateEnd, setErrors } = usePlannerContext();
  const [currentValue, setCurrentValue] = useState(
    value === null || value === undefined || value === -1
      ? ""
      : value.toString()
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errorAPI, setErrorAPI] = useState(false);

  // handle input change
  const handleChange = (e) => {
    const val = e.target.value;
    const error = validateBuildingName(val, type);
    setError(error);
    setCurrentValue(val);
    setErrorAPI(false);
  };

  const updateBuilding = async (buildingId, buildingInputs) => {
    setLoading(true);
    setErrorAPI(null);
    try {
      const response = await axiosInstance.put(
        `/buildings/updateBuilding/${buildingId}`,
        buildingInputs
      );

      setValue(currentValue);
      setEditMode(false);
    } catch (error) {
      // Handle error
      setErrorAPI(true);
      setEditMode(true);
    } finally {
      setLoading(false);
    }
  };

  const onBlurHandler = (e) => {
    if (area && area.buildingId && !error && value !== currentValue) {
      const buildingInputs = {
        ...area.building,
        name: currentValue,
      };

      updateBuilding(area.buildingId, buildingInputs);
    }
    if (!error && !errorAPI && value == currentValue) {
      setEditMode(false);
    }
  };

  const reloadHandler = () => {
    if (area && area.buildingId && !error) {
      const buildingInputs = {
        ...area.building,
        name: currentValue,
      };

      updateBuilding(area.buildingId, buildingInputs);
    }
  };

  useEffect(()=>{
    if(validateStart > 0){
      if(!!error || errorAPI){
        setErrors(prev => prev + 1);
      }
      setValidateEnd(prev => prev + 1)
    }
  }, [validateStart])
 
  

  return (
    <Box sx={{ width: "100%", display: "flex", alignItems: "flex-start", gap: '4px' }}>
      <FormControl error={!!error || errorAPI} variant="standard" sx={{ width: "100%" }}>
        {/* <Typography  sx={{ fontSize: "12px", color: "#343745", ml: "8px", mb: '4px', fontWeight: 500  }} >
        Name {unit && <span style={{ color: "#a2a3a3" }}>[{unit}]</span>} {requier && '*'}
      </Typography> */}
        <CustomInput
          value={currentValue}
          onChange={handleChange}
          onBlur={onBlurHandler}
          error={!!error}
          /* small={small} */
          placeholder={"Enter name"}
          name={name}
          autoFocus
          autoComplete="off"
          /* InputProps={{autoComplete: "off"}} */
        />
        {error && (
          <FormHelperText sx={{ pl: "8px", lineHeight: 1.2, color: "#9c0f0f !important" }}>
            {error}
          </FormHelperText>
        )}
        {errorAPI && (
          <FormHelperText sx={{ pl: "8px", lineHeight: 1.2, color: "#9c0f0f !important" }} id="component-error-text">
            Failed to save the value. Please click the reload button (
            {<IconReload stroke="#9c0f0f" width={"10px"} height={"10px"} />})
          </FormHelperText>
        )}
      </FormControl>
      {loading && <Box mt={'6px'} ><CircularProgress size={15} /></Box>}
      {errorAPI && (
        <IconButton sx={{ padding: "4px", mt: '2px' }} onClick={reloadHandler}>
          <IconReload stroke="#9c0f0f" width={"16px"} height={"16px"} />
        </IconButton>
      )}
    </Box>
  );
};
